import axios from "@/lib/axios";
import { API_ADMIN } from "../../utils/constants";

const csrf = () => axios.get("/sanctum/csrf-cookie");

export async function getLectureQuizQuestions({
  courseId,
  lectureId,
  itemId,
  filter,
  sortBy,
  includeFields,
  searchValue,
  page = 1,
  perPage = 10,
  filterAndSortAndPageQuery,
} = {}) {
  await csrf();

  // Base API Query
  let query = `/api/v1/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions`;

  if (filterAndSortAndPageQuery) query += filterAndSortAndPageQuery;

  //Search
  if (searchValue) {
    let searchQuery = `search=${searchValue}`;
    query += `${query.includes("?") ? "&" : "?"}${searchQuery}`;
  }

  //Filter
  if (Array.isArray(filter)) {
    let filterQuery = "";

    filter.forEach((el, index) => {
      filterQuery += `${index !== 0 ? "&" : ""}filter[${el.field}]=${el.value}`;
    });

    query += `${query.includes("?") ? "&" : "?"}${filterQuery}`;
  } else if (filter) {
    // Check if filter is a single object
    let filterQuery = `filter[${filter.field}]=${filter.value}`;

    query += `${query.includes("?") ? "&" : "?"}${filterQuery}`;
  }

  // Sorting
  if (Array.isArray(sortBy)) {
    let sortQuery = "";

    sortBy.forEach((el, index) => {
      const direction =
        el.direction === "ascending"
          ? ""
          : el.direction === "descending"
          ? "-"
          : "";
      sortQuery += `${index !== 0 ? "," : ""}${direction}${el.field}`;
    });

    query += `${query.includes("?") ? "&" : "?"}sort=${sortQuery}`;
  } else if (sortBy) {
    let sortQuery = `${sortBy.direction === "asc" ? "" : "-"}${sortBy.field}`;

    query += `${query.includes("?") ? "&" : "?"}sort=${sortQuery}`;
  }

  //includeFields
  if (Array.isArray(includeFields)) {
    let includeQuery = "include=";

    includeFields.forEach((el, index) => {
      includeQuery += `${index !== 0 ? "," : ""}${el}`;
    });

    query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
  } else if (includeFields) {
    let includeQuery = `include=${includeFields}`;

    query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
  }

  //Pagination
  if (page !== 0 && page >= 1) {
    query += `${query.includes("?") ? "&" : "?"}page=${page}${
      perPage ? "&perPage=" : ""
    }${perPage}`;
  }

  //Feaching The Data before adding all operations
  const response = await axios.get(query);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error(response.response.data.message);
  }
}

export async function getLectureQuizQuestion({
  courseId,
  lectureId,
  itemId,
  questionId,
} = {}) {
  await csrf();

  // Base API Query
  let query = `/api/v1/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/${questionId}`;

  //Feaching The Data before adding all operations
  const response = await axios.get(query);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error(response.response.data.message);
  }
}

export async function createLectureQuizQuestion({
  courseId,
  lectureId,
  itemId,
  question,
  image,
}) {
  await csrf();

  const updatedQuizQuestion = {
    question,
    image,
  };
  const filteredQuizQuestion = Object.fromEntries(
    Object.entries(updatedQuizQuestion).filter(
      ([, value]) => value !== undefined
    )
  );
  const response = await axios.post(
    `api/v1/admin/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions`,
    filteredQuizQuestion
  );

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error(response.response.data.message);
  }
}

export async function updateLectureQuizQuestion({
  courseId,
  lectureId,
  itemId,
  questionId,
  question,
  image,
}) {
  await csrf();

  const updatedQuizQuestion = {
    question,
    image,
  };
  const filteredQuizQuestion = Object.fromEntries(
    Object.entries(updatedQuizQuestion).filter(
      ([, value]) => value !== undefined && value !== null
    )
  );
  const response = await axios.patch(
    `${API_ADMIN}/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/${questionId}`,
    filteredQuizQuestion
  );

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error(response.response.data.message);
  }
}

export async function deleteLectureQuizQuesion({
  courseId,
  lectureId,
  itemId,
  questionId,
}) {
  await csrf();

  const response = await axios.delete(
    `${API_ADMIN}/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/${questionId}`
  );

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error(response.response.data.message);
  }
}

// OptionsApi
export async function createLectureQuizOptions({
  courseId,
  lectureId,
  itemId,
  questionId,

  option,
  is_correct = 0,
}) {
  await csrf();

  const createQuizOpions = {
    option,
    is_correct,
  };

  const response = await axios.post(
    `${API_ADMIN}/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/${questionId}/options`,
    createQuizOpions
  );

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error(response.response.data.message);
  }
}

export async function getLectureQuizOpions({
  courseId,
  lectureId,
  itemId,
  questionId,
  filter,
  sortBy,
  includeFields,
  searchValue,
  page = 1,
  perPage = 10,
  filterAndSortAndPageQuery,
}) {
  await csrf();

  // Base API Query
  let query = `${API_ADMIN}/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/${questionId}/options`;

  if (filterAndSortAndPageQuery) query += filterAndSortAndPageQuery;

  //Search
  if (searchValue) {
    let searchQuery = `search=${searchValue}`;
    query += `${query.includes("?") ? "&" : "?"}${searchQuery}`;
  }

  //Filter
  if (Array.isArray(filter)) {
    let filterQuery = "";

    filter.forEach((el, index) => {
      filterQuery += `${index !== 0 ? "&" : ""}filter[${el.field}]=${el.value}`;
    });

    query += `${query.includes("?") ? "&" : "?"}${filterQuery}`;
  } else if (filter) {
    // Check if filter is a single object
    let filterQuery = `filter[${filter.field}]=${filter.value}`;

    query += `${query.includes("?") ? "&" : "?"}${filterQuery}`;
  }

  // Sorting
  if (Array.isArray(sortBy)) {
    let sortQuery = "";

    sortBy.forEach((el, index) => {
      const direction =
        el.direction === "ascending"
          ? ""
          : el.direction === "descending"
          ? "-"
          : "";
      sortQuery += `${index !== 0 ? "," : ""}${direction}${el.field}`;
    });

    query += `${query.includes("?") ? "&" : "?"}sort=${sortQuery}`;
  } else if (sortBy) {
    let sortQuery = `${sortBy.direction === "asc" ? "" : "-"}${sortBy.field}`;

    query += `${query.includes("?") ? "&" : "?"}sort=${sortQuery}`;
  }

  //includeFields
  if (Array.isArray(includeFields)) {
    let includeQuery = "include=";

    includeFields.forEach((el, index) => {
      includeQuery += `${index !== 0 ? "," : ""}${el}`;
    });

    query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
  } else if (includeFields) {
    let includeQuery = `include=${includeFields}`;

    query += `${query.includes("?") ? "&" : "?"}${includeQuery}`;
  }

  //Pagination
  if (page !== 0 && page >= 1) {
    query += `${query.includes("?") ? "&" : "?"}page=${page}${
      perPage ? "&perPage=" : ""
    }${perPage}`;
  }

  //Feaching The Data before adding all operations
  const response = await axios.get(query);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error(response.response.data.message);
  }
}

export async function updateLectureQuizOption({
  courseId,
  lectureId,
  itemId,
  questionId,
  optionId,
  option,
  is_correct,
}) {
  await csrf();

  const updatedQuizOption = {
    option,
    is_correct,
  };

  const response = await axios.patch(
    `${API_ADMIN}/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/${questionId}/options/${optionId}`,
    updatedQuizOption
  );

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error(response.response.data.message);
  }
}

export async function deleteLectureQuizOption({
  courseId,
  lectureId,
  itemId,
  questionId,
  optionId,
}) {
  await csrf();

  const response = await axios.delete(
    `${API_ADMIN}/courses/${courseId}/lectures/${lectureId}/items/${itemId}/questions/${questionId}/options/${optionId}`
  );

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error(response.response.data.message);
  }
}
